// Import Swiper and styles
const swiper = new Swiper('.slider', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 1000,
  spaceBetween: 10,
  effect: 'cube',
  shadow: true,
  shadowOffset: 20,
  shadowScale: 0.94,
  slideShadows: true,
 



  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  // },

    // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination',
  // },

});

